import { getStats, resetStats } from "src/lib/Stats/statsMain"
import Button from "./Button";
import { useCallback, useState } from "react";

export function StatsDisplay() {
    const [ allStats, setAllStats ] = useState(getStats());

    const updateStats = useCallback(() => {
        setAllStats(getStats());
    }, [ setAllStats ]);

    return (
        <div className="p-4 overflow-y-scroll h-full">
            <h1>Individual Problem Stats</h1>
            <Button onClick={() => { resetStats(); updateStats(); }}>Reset Stats</Button>
            {
                Object.entries(allStats).map(([ generator, stats], idx ) => {
                    return (
                        <div key={idx}>
                            <div className="font-bold">{generator}</div>
                            <div>
                            {
                                stats.sort((a,b) => a.problem.display.localeCompare(b.problem.display) ).map((probStat, idx) => {
                                    return (
                                        <div key={idx}>{probStat.problem.display} - {probStat.correct}/{probStat.correct + probStat.incorrect} - {probStat.averageTime}ms</div>
                                    )
                                })

                            }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}